import { VehicleEntity } from "@ots-frontend/ots-data";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseVehicleSelectProps = BaseEntitySelectProps<VehicleEntity>;

export const BaseVehicleSelect = (props: BaseVehicleSelectProps) => {
  return <BaseEntitySelect {...props} />;
};
